<template>
 
  <div id="topNav">
    <div class="menuBtn" :class="{ active: showMenu }" @click="showMenu = !showMenu">
      <span class="menuLine"></span>
      <span class="menuLine"></span>
      <span class="menuLine"></span>
    </div>
    <div class="logos">
      <img src="@/assets/icons/Logomark.svg" class="logoMark" :class="{ active: showMenu }" />
      <img src="@/assets/icons/rayscom.svg" class="raysCom" :class="{ active: showMenu }" />
      <div class="repInfo">
        <b-row>
          <b-col :class="{ active: showMenu }">
            <img v-if="rep === 'Kenzie Dill'" src="@/assets/images/Kenzie-Dill.png" alt="rep" />
            <img v-if="rep === 'Emilee Bell'" src="@/assets/images/Emilee-Bell.png" alt="rep" />
            <img v-if="rep === 'Matt Gianoni'" src="@/assets/images/Matt-Gianoni.png" alt="rep" />
            <img v-if="rep === 'Megan Paul'" src="@/assets/images/Megan-Paul.png" alt="rep" />
            <p v-if="rep === 'Your Rays Representative Ticket Sales'" class="repName noRep">{{rep}}</p>
            <p v-else class="repName">Rays Representative {{rep}}</p>
            <p class="repContact">{{repPhone}}  &bull; <a :href="`mailto:` + repEmail">{{repEmail}}</a></p>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="extLinks" :class="{ active: showMenu }">
      <a href="https://www.facebook.com/Rays/" target="_blank"><img src="@/assets/icons/app/facebook.svg" /></a>
      <a href="https://twitter.com/RaysBaseball" target="_blank"><img src="@/assets/icons/app/twitter.svg" /></a>
      <a href="https://www.instagram.com/raysbaseball/" target="_blank"><img src="@/assets/icons/app/instagram.svg" /></a>
      <span v-if="credit != ' $ -   '">Account Credit: {{credit}}</span>
      <div class="renewBtn">
        <a v-scroll-to="'#Renew'" v-ePitchTracking="'Renew Now'">Renew Now</a>
      </div>
    </div>
    <div class="primaryNav" :class="{ active: showMenu }">
      <div id="primary-nav" :class="{ active: showMenu }">
        <div class="topNavLogos">
          <img src="@/assets/icons/rayscom-blue.svg" class="raysCom" />
          <img src="@/assets/icons/888rays.svg" class="raysPhone" />
        </div>
        <b-nav v-b-scrollspy="{ offset: 200 }">
          <div class="p-nav-links">
            <b-nav-item
              class="p-nav-link"
              v-for="(link, index) in primaryLinks"
              :key="'p-nav' + index"
              :href="link.to"
              v-scroll-to="link.to"
              @click="showMenu = !showMenu"
            >
              {{link.title}}
            </b-nav-item>
          </div>
        </b-nav>
        <div class="bottomIcons">
          <a href="https://www.facebook.com/Rays/" target="_blank"><img src="@/assets/icons/app/facebook.svg" /></a>
          <a href="https://twitter.com/RaysBaseball" target="_blank"><img src="@/assets/icons/app/twitter.svg" /></a>
          <a href="https://www.instagram.com/raysbaseball/" target="_blank"><img src="@/assets/icons/app/instagram.svg" /></a>
        </div>
      </div>
    </div>
    <div class="navOverlay" @click="showMenu = !showMenu" :class="{ active: showMenu }">
    </div>
  </div>
</template>

<script>
import { navData } from "@/data/navData";
import { mapState } from "vuex";
export default {
  name: "TopNav",
  computed: {
    ...mapState(["global"])
  },
 data() {
		return {
      primaryLinks: navData().primaryLinks,
      showMenu: false,
      credit: null,
      rep: null,
      repEmail: null,
      repPhone: null
    }
  },
  created(){
    let userInfo = this.$store.state.global.userInfo;
    this.credit = userInfo.totalCredit
    this.rep = userInfo.repName
    this.repEmail = userInfo.repEmail
    this.repPhone = userInfo.repPhone
  }
  // mounted() {
	// 	var el = document.getElementById('primary-nav');
	// 	document.addEventListener('click', function(event) {
  //     var isClickInside = el.contains(event.target);
	// 		if (!isClickInside) {
	// 			el.classList.remove('active');
	// 		}
	// 	});
	// }
};
</script>

<style lang="scss" scoped>
#topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 80px;
  z-index: 999;
  background-color: $dark-blue;
  .menuBtn {
    position: absolute;
    left: 0;
    top: 0;
    width: 90px;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1001;
    transition: all 0.3s ease-in-out;
   
    &.active {
      left: 250px;
       @media only screen and (max-width: $sm) {
        left: 220px;
      }
      .menuLine {
        &:first-child {
          transform: rotate(45deg);
          top: 47.5%;
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:last-child {
          transform: rotate(-45deg);
          bottom: 47.5%;
        }
      }
    }
    .menuLine {
      position: relative;
      background-color: $dark-blue;
      height: 4px;
      width: 30%;
      border-radius: 3px;
      &:first-child {
        position: absolute;
        top: 33%;
        transition: all 0.3s ease-in-out;
      }
      &:nth-child(2) {
        position: absolute;
        opacity: 1;
        transition: all 0.3s ease-in-out;
      }
      &:last-child {
        position: absolute;
        bottom: 33%;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  .logos {
    position: absolute;
    left: 115px;
    top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    .logoMark {
      transition: all 0.3s ease-in-out;
      z-index: 1002;
      @media only screen and (max-width: $sm) {
        width: 35px;
        position: relative;
        top: 10px;
      }
      &.active {
        margin-left: 250px;
        @media only screen and (max-width: $sm) {
          margin-left: 450px;
        }
      }
    }
    .raysCom {
      margin: 8px 0 0 20px;
      opacity: 1;
      transition: all 0.3s ease-in-out;
      @media only screen and (max-width: $xl) {
        display: none;
      }
      &.active {
        opacity: 0;
      }
    }
    .raysPhone {
      margin: -2px 0 0 25px;
      opacity: 1;
      transition: all 0.3s ease-in-out;
      &.active {
        opacity: 0;
      }
    }
    .repInfo {
      margin-top: 0;
      position: absolute;
      left: 275px;
      top: 0px;
      width: 500px;
      @media only screen and (max-width: $xl) {
        display: none;
      }
      .active {
        opacity: 0;
      }
      img {
        float: left;
        width: 50px;
        height: 50px;
      }
      p {
        margin-left: 65px;
        &.repName {
          font-family: 'UniversLTStd-Bold';
          font-size: 14px;
          color: $light-blue;
          margin-top: 5px;
        }
        &.repContact {
          font-family: 'UniversLTStd-Bold';
          font-size: 16px;
          color: #fff;
          a {
            font-family: 'UniversLTStd-Bold';
            font-size: 14px;
            color: #fff;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .extLinks {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    transition: all 0.3s ease-in-out;
    &.active {
      opacity: 0;
    }
    img {
      margin: 0 5px;
      @media only screen and (max-width: $md) {
        display: none;
      }
    }
    span {
      font-family: 'UniversLTStd';
      color: $grey-blue;
      font-size: 14px;
      margin: 0 0 0 25px;
      @media only screen and (max-width: $md) {
        display: none;
      }
    }
    .renewBtn {
      margin: 0 30px;
      a {
        font-family: 'UniversLTStd';
        font-size: 14px;
        color: #fff;
        border: 2px solid $yellow;
        border-radius: 25px;
        padding: 8px 20px;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  .primaryNav {
    position: absolute;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: none;
    visibility: hidden;
    opacity: 0;
    z-index: 1000;
    transition: all 0.5s ease-in-out;
    &.active {
      visibility: visible;
      opacity: 1;
      background-color: rgba(0,0,0,0.5);
    }
    #primary-nav {
      position: fixed;
      height: 100%;
      width: 350px;
      top: 0;
      left: -100%;
      background-color: #fff;
      transition: all 0.3s ease-in-out;
      @media(max-width: $xl){
        padding-right: 6.2vw;
      }
      &.active {
        left: 0;
      }
      .topNavLogos {
        position: absolute;
        top: 20px;
        left: 20px;
      }
      /**Adjust this padding for mobile, remove and justify center */
      .p-nav-links {
        height: 100%;
        background: transparent;
        padding-top: 250px;
        @media(max-width: $md){
          padding-top: 100px;
        }
        .highlight {
          height: 3px;
          width: 100%;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          background: #ffffff;
          box-shadow: inset 0 -2px 1px 0 rgba(0, 0, 0, 0.41);
        }

        .p-nav-link {
          position: relative;
          height: 100%;
          padding: 0 0 0 5px;
          a {
            font-family: 'UniversLTStd-Bold';
            font-size: 14px;
            color: #000000;
            opacity: 0.5;
            letter-spacing: 0;
            transition: all 0.3s ease-in-out;
            &:hover {
              opacity: 1;
            }
          }
        }
        .active {
          a {
            color: $dark-blue;
            opacity: 1;
          }
        }
      }
      .bottomIcons {
        position: absolute;
        bottom: 15px;
        display: flex;
        a {
          padding: 0 15px;
        }
      }
    }
  }
  .navOverlay {
    position: absolute;
    right: 0;
    width: 75vw;
    height: 100vh;
    background-color: none;
    visibility: hidden;
    opacity: 0;
    z-index: 1003;
    transition: all 0.5s ease-in-out;
    @media only screen and (max-width: $xl) {
      width: 65vw;
    }
    @media only screen and (max-width: $lg) {
      width: 58vw;
    }
    @media only screen and (max-width: $md) {
      width: 25vw;
    }
    @media only screen and (max-width: $sm) {
      width: 10vw;
    }
    &.active {
      visibility: visible;
      opacity: 1;
      background-color: none;
    }
  }
}
</style>